import { render, staticRenderFns } from "./StackModal.vue?vue&type=template&id=2d3db1d8&scoped=true&"
import script from "./StackModal.vue?vue&type=script&lang=js&"
export * from "./StackModal.vue?vue&type=script&lang=js&"
import style0 from "./StackModal.vue?vue&type=style&index=0&id=2d3db1d8&lang=scss&scoped=true&"
import style1 from "./StackModal.vue?vue&type=style&index=1&id=2d3db1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3db1d8",
  null
  
)

export default component.exports